export default "__VITE_ASSET__CezY3y8c__"